module.exports = __webpack_public_path__ + "img/clock.93943154.png";